import { stripHtml } from "@/utils/format";

interface RoomType {
  id: number;
  name: string;
  bed: string;
  area: string;
  breakfast: string;
  available: number;
  price: number;
}

interface RoomListProps {
  rooms: RoomType[];
  selectedRoomId: number | null;
  onRoomSelect: (id: number) => void;
  loading?: boolean;
}

export default function RoomList({ rooms, selectedRoomId, onRoomSelect, loading }: RoomListProps) {
  return (
    <div className="bg-white mt-2 px-5 py-4">
      <div className="text-sm font-semibold text-gray-800 mb-3">选择房型</div>
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12">
          <i
            className="ri-loader-4-line animate-spin"
            style={{ fontSize: 32, color: "#1E3A8A" }}
          />
          <span className="text-sm text-gray-400 mt-3">加载中...</span>
        </div>
      ) : (
      <div className="space-y-3">
        {rooms.map((room) => (
          <div
            key={room.id}
            onClick={() => onRoomSelect(room.id)}
            className="rounded-2xl p-4 cursor-pointer transition-all"
            style={{
              border: `1.5px solid ${selectedRoomId === room.id ? "#F97316" : "#E5E7EB"}`,
              background: selectedRoomId === room.id ? "#FFF7ED" : "#fff",
            }}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-gray-800">{stripHtml(room.name)}</div>
                <div className="flex flex-wrap gap-2 mt-1.5 text-xs text-gray-500">
                  <span><i className="ri-hotel-bed-line mr-1" style={{ fontSize: 12 }} />{stripHtml(room.bed)}</span>
                  <span><i className="ri-ruler-2-line mr-1" style={{ fontSize: 12 }} />{stripHtml(room.area)}</span>
                  <span className="text-green-600"><i className="ri-restaurant-line mr-1" style={{ fontSize: 12 }} />{stripHtml(room.breakfast)}</span>
                </div>
                <div className="mt-1.5 text-xs" style={{ color: "#10B981" }}>
                  {room.available > 0 ? `剩余 ${room.available} 间 · 速预订` : "速预订"}
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="font-bold" style={{ color: "#EF4444", fontSize: 20 }}>¥{room.price}</div>
                {/* <div className="text-xs text-gray-400">/ 晚</div> */}
              </div>
            </div>
            {selectedRoomId === room.id && (
              <div className="mt-2 flex items-center gap-1.5 text-xs" style={{ color: "#F97316" }}>
                <i className="ri-checkbox-circle-fill" style={{ fontSize: 14 }} />
                <span>已选择此房型</span>
              </div>
            )}
          </div>
        ))}
      </div>
      )}
    </div>
  );
}
